import { Button, DynamicInput, FormField } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import useCampaign, { useCampaignForm } from '@hooks/useCampaign'

import { fieldTypes } from '@models/campaign'
import type { CampaignModel, CampaignParamKey } from '@models/types'

interface RequiredCampaignFieldsProps {
  campaign: CampaignModel,
  missingFields: CampaignParamKey[],
}

const RequiredCampaignFields = (props: RequiredCampaignFieldsProps) => {
  const { campaign, missingFields } = props

  const campaignPayload = useCampaign(campaign)
  const {
    callbacks: {
      updateCampaign: updateFn,
    },
    updating,
  } = campaignPayload

  const campaignFormPayload = useCampaignForm(campaign)
  const {
    entityState,
    handlers,
  } = campaignFormPayload

  const filteredFields = Object.values(fieldTypes)
    .filter(field => missingFields.includes(field.key))

  const updateCampaignPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Campaign Updated',
  }

  return (
    <FormField
      boxProps={{ marginBottom: 'large' }}
      direction="column"
      label="Required Fields"
      marginTop="small"
    >
      {filteredFields.map((field, index) => {
        const { key, inputType, label } = field
        const fieldValue = entityState[key]

        return (
          <DynamicInput
            currentValue={fieldValue || ''}
            key={key}
            // @ts-expect-error TS2322
            inputType={inputType}
            name={key}
            placeholder={label}
            style={{
              // @ts-expect-error TS2322
              marginBottom: index + 1 === filteredFields.length ? 0 : 4,
            }}
            type="input"
            {...handlers}
          />
        )
      })}

      <Button
        buttonStyle="primaryEdit"
        size="medium"
        loading={updating}
        loadingBubbleColor="white"
        // @ts-expect-error TS2345
        onClick={() => handleCallbackAction(updateCampaignPayload)}
        // @ts-expect-error TS2322
        marginTop="small"
        width="auto"
      >
        Save Missing Fields
      </Button>
    </FormField>
  )
}

export default RequiredCampaignFields
